import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

export const initialState = {};

const reducer = handleActions(
  {
    [Actions.DEFINE_EXPERIMENT]: (
      state,
      { payload: { name, variants, weights } },
    ) => ({
      ...state,
      [name]: {
        variants,
        weights,
      },
    }),
  },
  initialState,
);

export default reducer;
